export const dogBreeds = [
  { id: 1, value: 'Afghan Hound' },
  { id: 2, value: 'Africanis' },
  { id: 3, value: 'Aidi' },
  { id: 4, value: 'Airedale Terrier' },
  { id: 5, value: 'Akbash' },
  { id: 6, value: 'Akita' },
  { id: 7, value: 'Aksaray Malaklisi' },
  { id: 8, value: 'Alano Español' },
  { id: 9, value: 'Alapaha Blue Blood Bulldog' },
  { id: 10, value: 'Alaskan husky' },
  { id: 11, value: 'Alaskan Klee Kai' },
  { id: 12, value: 'Alaskan Malamute' },
  { id: 13, value: 'Alopekis' },
  { id: 14, value: 'Alpine Dachsbracke' },
  { id: 15, value: 'American Bulldog' },
  { id: 16, value: 'American Bully' },
  { id: 17, value: 'American Cocker Spaniel' },
  { id: 18, value: 'American English Coonhound' },
  { id: 19, value: 'American Eskimo Dog' },
  { id: 20, value: 'American Foxhound' },
  { id: 21, value: 'American Hairless Terrier' },
  { id: 22, value: 'American Leopard Hound' },
  { id: 23, value: 'American Pit Bull Terrier' },
  { id: 24, value: 'American Staffordshire Terrier' },
  { id: 25, value: 'American Water Spaniel' },
  { id: 26, value: 'Anglo-Français de Petite Vénerie' },
  { id: 27, value: 'Appenzeller Sennenhund' },
  { id: 28, value: 'Ariège Pointer' },
  { id: 29, value: 'Ariégeois' },
  { id: 30, value: 'Argentine Pila' },
  { id: 31, value: 'Armant' },
  { id: 32, value: 'Armenian Gampr' },
  { id: 33, value: 'Artois Hound' },
  { id: 34, value: 'Assyrian Mastiff' },
  { id: 35, value: 'Australian Cattle Dog' },
  { id: 36, value: 'Australian Kelpie' },
  { id: 37, value: 'Australian Shepherd' },
  { id: 38, value: 'Australian Stumpy Tail Cattle Dog' },
  { id: 39, value: 'Australian Terrier' },
  { id: 40, value: 'Austrian Black and Tan Hound' },
  { id: 41, value: 'Austrian Pinscher' },
  { id: 42, value: 'Australian Silky Terrier' },
  { id: 43, value: 'Azawakh' },
  { id: 44, value: 'Bắc Hà' },
  { id: 45, value: 'Bakharwal' },
  { id: 46, value: 'Banjara Hound' },
  { id: 47, value: 'Bankhar Dog' },
  { id: 48, value: 'Barak hound' },
  { id: 49, value: 'Barbado da Terceira' },
  { id: 50, value: 'Barbet' },
  { id: 51, value: 'Basenji' },
  { id: 52, value: 'Basque Shepherd Dog' },
  { id: 53, value: 'Basset Artésien Normand' },
  { id: 54, value: 'Basset Bleu de Gascogne' },
  { id: 55, value: 'Basset Fauve de Bretagne' },
  { id: 56, value: 'Basset Hound' },
  { id: 57, value: 'Bavarian Mountain Hound' },
  { id: 58, value: 'Beagle' },
  { id: 59, value: 'Beagle-Harrier' },
  { id: 60, value: 'Bearded Collie' },
  { id: 61, value: 'Beauceron' },
  { id: 62, value: 'Bedlington Terrier' },
  { id: 63, value: 'Belgian Shepherd' },
  { id: 64, value: 'Bergamasco Shepherd' },
  { id: 65, value: 'Berger Picard' },
  { id: 66, value: 'Bernese Mountain Dog' },
  { id: 67, value: 'Bichon Frisé' },
  { id: 68, value: 'Biewer Terrier' },
  { id: 69, value: 'Billy' },
  { id: 70, value: 'Black and Tan Coonhound' },
  { id: 71, value: 'Black and Tan Terrier' },
  { id: 72, value: 'Black Norwegian Elkhound' },
  { id: 73, value: 'Black Russian Terrier' },
  { id: 74, value: 'Black Mouth Cur' },
  { id: 75, value: 'Bloodhound' },
  { id: 76, value: 'Blue Lacy' },
  { id: 77, value: 'Blue Picardy Spaniel' },
  { id: 78, value: 'Bluetick Coonhound' },
  { id: 79, value: 'Boerboel' },
  { id: 80, value: 'Bohemian Shepherd' },
  { id: 81, value: 'Bolognese' },
  { id: 82, value: 'Border Collie' },
  { id: 83, value: 'Border Terrier' },
  { id: 84, value: 'Borzoi' },
  { id: 85, value: 'Boston Terrier' },
  { id: 86, value: 'Bouvier des Ardennes' },
  { id: 87, value: 'Bouvier des Flandres' },
  { id: 88, value: 'Boxer' },
  { id: 89, value: 'Boykin Spaniel' },
  { id: 90, value: 'Bracco Italiano' },
  { id: 91, value: 'Braque dAuvergne' },
  { id: 92, value: 'Braque du Bourbonnais' },
  { id: 93, value: 'Braque Français' },
  { id: 94, value: 'Brazilian Terrier' },
  { id: 95, value: 'Briard' },
  { id: 96, value: 'Briquet de Provence' },
  { id: 97, value: 'Briquet Griffon Vendéen' },
  { id: 98, value: 'Brittany' },
  { id: 99, value: 'Broholmer' },
  { id: 100, value: 'Bruno Jura Hound' },
  { id: 101, value: 'Bucovina Shepherd Dog' },
  { id: 102, value: 'Bulgarian Hound' },
  { id: 103, value: 'Bulgarian Scenthound' },
  { id: 104, value: 'Bull Arab' },
  { id: 105, value: 'Bull Terrier' },
  { id: 106, value: 'Bulldog' },
  { id: 107, value: 'Bullmastiff' },
  { id: 108, value: 'Burgos Pointer' },
  { id: 109, value: 'Ca Mè Mallorquí' },
  { id: 110, value: 'Ca de Bou' },
  { id: 111, value: 'Ca Rater Mallorquí' },
  { id: 112, value: 'Cairn Terrier' },
  { id: 113, value: 'Calupoh' },
  { id: 114, value: 'Campeiro Bulldog' },
  { id: 115, value: 'Can de Chira' },
  { id: 116, value: 'Can de Palleiro' },
  { id: 117, value: 'Canaan Dog' },
  { id: 118, value: 'Canadian Eskimo Dog' },
  { id: 119, value: 'Cane Corso' },
  { id: 120, value: 'Cane di Oropa' },
  { id: 121, value: 'Cane Paratore' },
  { id: 122, value: 'Cantabrian Water Dog' },
  { id: 123, value: 'Cão de Gado Transmontano' },
  { id: 124, value: 'Cardigan Welsh Corgi' },
  { id: 125, value: 'Carea Leonés' },
  { id: 126, value: 'Carolina Dog' },
  { id: 127, value: 'Carpathian Shepherd Dog' },
  { id: 128, value: 'Castro Laboreiro Dog' },
  { id: 129, value: 'Catahoula Leopard Dog' },
  { id: 130, value: 'Catalan Sheepdog' },
  { id: 131, value: 'Caucasian Shepherd Dog' },
  { id: 132, value: 'Cavalier King Charles Spaniel' },
  { id: 133, value: 'Central Asian Shepherd Dog' },
  { id: 134, value: 'Český fousek' },
  { id: 135, value: 'Český strakatý pes' },
  { id: 136, value: 'Cesky Terrier' },
  { id: 137, value: 'Chesapeake Bay Retriever' },
  { id: 138, value: 'Chien Français Blanc et Noir' },
  { id: 139, value: 'Chien Français Blanc et Orange' },
  { id: 140, value: 'Chien Français Tricolore' },
  { id: 141, value: 'Chihuahua' },
  { id: 142, value: 'Chilean Terrier' },
  { id: 143, value: 'Chinese Crested Dog' },
  { id: 144, value: 'Chinook' },
  { id: 145, value: 'Chippiparai' },
  { id: 146, value: 'Chongqing' },
  { id: 147, value: 'Chortai' },
  { id: 148, value: 'Chow Chow' },
  { id: 149, value: 'Chukotka sled dog' },
  { id: 150, value: 'Cimarrón Uruguayo' },
  { id: 151, value: 'Cirneco dell Etna' },
  { id: 152, value: 'Clumber Spaniel' },
  { id: 153, value: 'Colombian Fino Hound' },
  { id: 154, value: 'Continental bulldog' },
  { id: 155, value: 'Corsican Dog' },
  { id: 156, value: 'Coton de Tulear' },
  { id: 157, value: 'Cretan Hound' },
  { id: 158, value: 'Croatian Sheepdog' },
  { id: 159, value: 'Curly-coated Retriever' },
  { id: 160, value: 'Czechoslovakian Wolfdog' },
  { id: 161, value: 'Daschund' },
  { id: 162, value: 'Dalmatian' },
  { id: 163, value: 'Dandie Dinmont Terrier' },
  { id: 164, value: 'Danish Spitz' },
  { id: 165, value: 'Danish–Swedish Farmdog' },
  { id: 166, value: 'Denmark Feist' },
  { id: 167, value: 'Dikkulak' },
  { id: 168, value: 'Dingo ' },
  { id: 169, value: 'Dobermann' },
  { id: 170, value: 'Dogo Argentino' },
  { id: 171, value: 'Dogo Sardesco' },
  { id: 172, value: 'Dogue Brasileiro' },
  { id: 173, value: 'Dogue de Bordeaux' },
  { id: 174, value: 'Donggyeongi' },
  { id: 175, value: 'Drentse Patrijshond' },
  { id: 176, value: 'Drever' },
  { id: 177, value: 'Dunker' },
  { id: 178, value: 'Dutch Shepherd' },
  { id: 179, value: 'Dutch Smoushond' },
  { id: 180, value: 'East Siberian Laika' },
  { id: 181, value: 'East European Shepherd' },
  { id: 182, value: 'Ecuadorian Hairless Dog' },
  { id: 183, value: 'English Cocker Spaniel' },
  { id: 184, value: 'English Foxhound' },
  { id: 185, value: 'English Mastiff' },
  { id: 186, value: 'English Setter' },
  { id: 187, value: 'English Shepherd' },
  { id: 188, value: 'English Springer Spaniel' },
  { id: 189, value: 'English Toy Terrier (Black & Tan)' },
  { id: 190, value: 'Entlebucher Mountain Dog' },
  { id: 191, value: 'Erbi Txakur' },
  { id: 192, value: 'Estonian Hound' },
  { id: 193, value: 'Estrela Mountain Dog' },
  { id: 194, value: 'Eurasier' },
  { id: 195, value: 'Faroese Sheepdog' },
  { id: 196, value: 'Field Spaniel' },
  { id: 197, value: 'Fila Brasileiro' },
  { id: 198, value: 'Finnish Hound' },
  { id: 199, value: 'Finnish Lapphund' },
  { id: 200, value: 'Finnish Spitz' },
  { id: 201, value: 'Flat-coated Retriever' },
  { id: 202, value: 'French Bulldog' },
  { id: 203, value: 'French Spaniel' },
  { id: 204, value: 'Galgo Español' },
  { id: 205, value: 'Gascon Saintongeois' },
  { id: 206, value: 'Gaucho sheepdog' },
  { id: 207, value: 'Georgian Shepherd' },
  { id: 208, value: 'German Hound' },
  { id: 209, value: 'German Longhaired Pointer' },
  { id: 210, value: 'German Pinscher' },
  { id: 211, value: 'German Roughhaired Pointer' },
  { id: 212, value: 'German Shepherd' },
  { id: 213, value: 'German Shorthaired Pointer' },
  { id: 214, value: 'German Spaniel' },
  { id: 215, value: 'German Spitz' },
  { id: 216, value: 'German Wirehaired Pointer' },
  { id: 217, value: 'Giant Schnauzer' },
  { id: 218, value: 'Glen of Imaal Terrier' },
  { id: 219, value: 'Golden Retriever' },
  { id: 220, value: 'Gończy Polski' },
  { id: 221, value: 'Gordon Setter' },
  { id: 222, value: 'Grand Anglo-Français Blanc et Noir' },
  { id: 223, value: 'Grand Anglo-Français Blanc et Orange' },
  { id: 224, value: 'Grand Anglo-Français Tricolore' },
  { id: 225, value: 'Grand Basset Griffon Vendéen' },
  { id: 226, value: 'Grand Bleu de Gascogne' },
  { id: 227, value: 'Grand Griffon Vendéen' },
  { id: 228, value: 'Great Dane' },
  { id: 229, value: 'Greater Swiss Mountain Dog' },
  { id: 230, value: 'Greek Harehound' },
  { id: 231, value: 'Greek Shepherd' },
  { id: 232, value: 'Greenland Dog' },
  { id: 233, value: 'Greyhound' },
  { id: 234, value: 'Griffon Bleu de Gascogne' },
  { id: 235, value: 'Griffon Bruxellois' },
  { id: 236, value: 'Griffon Fauve de Bretagne' },
  { id: 237, value: 'Griffon Nivernais' },
  { id: 238, value: 'Guatemalan Dogo' },
  { id: 239, value: 'Gull Dong' },
  { id: 240, value: 'Gull Terrier' },
  { id: 241, value: 'Hällefors Elkhound' },
  { id: 242, value: 'Halden Hound' },
  { id: 243, value: 'Hamiltonstövare' },
  { id: 244, value: 'Hanover Hound' },
  { id: 245, value: 'Harrier' },
  { id: 246, value: 'Havanese' },
  { id: 247, value: 'Himalayan Sheepdog' },
  { id: 248, value: 'Hmong bobtail dog' },
  { id: 249, value: 'Hokkaido' },
  { id: 250, value: 'Hovawart' },
  { id: 251, value: 'Huntaway' },
  { id: 252, value: 'Hygen Hound' },
  { id: 253, value: 'Ibizan Hound' },
  { id: 254, value: 'Icelandic Sheepdog' },
  { id: 255, value: 'Indian pariah dog' },
  { id: 256, value: 'Indian Spitz' },
  { id: 257, value: 'Irish Red and White Setter' },
  { id: 258, value: 'Irish Setter' },
  { id: 259, value: 'Irish Terrier' },
  { id: 260, value: 'Irish Water Spaniel' },
  { id: 261, value: 'Irish Wolfhound' },
  { id: 262, value: 'Istrian Coarse-haired Hound' },
  { id: 263, value: 'Istrian Shorthaired Hound' },
  { id: 264, value: 'Italian Greyhound' },
  { id: 265, value: 'Jack Russell Terrier' },
  { id: 266, value: 'Jagdterrier' },
  { id: 267, value: 'Jämthund' },
  { id: 268, value: 'Japanese Chin' },
  { id: 269, value: 'Japanese Spitz' },
  { id: 270, value: 'Japanese Terrier' },
  { id: 271, value: 'Jeju' },
  { id: 272, value: 'Jonangi' },
  { id: 273, value: 'Kai Ken' },
  { id: 274, value: 'Kaikadi' },
  { id: 275, value: 'Kamchatka Sled Dog' },
  { id: 276, value: 'Kangal Shepherd Dog' },
  { id: 277, value: 'Kanni' },
  { id: 278, value: 'Karakachan' },
  { id: 279, value: 'Karelian Bear Dog' },
  { id: 280, value: 'Karelo-Finnish Laika' },
  { id: 281, value: 'Kars' },
  { id: 282, value: 'Karst Shepherd' },
  { id: 283, value: 'Keeshond' },
  { id: 284, value: 'Kerry Beagle' },
  { id: 285, value: 'Kerry Blue Terrier' },
  { id: 286, value: 'Khala' },
  { id: 287, value: 'King Charles Spaniel' },
  { id: 288, value: 'King Shepherd' },
  { id: 289, value: 'Kintamani' },
  { id: 290, value: 'Kishu' },
  { id: 291, value: 'Kokoni' },
  { id: 292, value: 'Kombai' },
  { id: 293, value: 'Komondor' },
  { id: 294, value: 'Kooikerhondje' },
  { id: 295, value: 'Koolie' },
  { id: 296, value: 'Korean Jindo' },
  { id: 297, value: 'Kromfohrländer' },
  { id: 298, value: 'Kuchi' },
  { id: 299, value: 'Kunming' },
  { id: 300, value: 'Kurdish Mastiff' },
  { id: 301, value: 'Kuvasz' },
  { id: 302, value: 'L–R' },
  { id: 303, value: 'Labrador Retriever' },
  { id: 304, value: 'Lagotto Romagnolo' },
  { id: 305, value: 'Lài' },
  { id: 306, value: 'Lakeland Terrier' },
  { id: 307, value: 'Lancashire Heeler' },
  { id: 308, value: 'Landseer' },
  { id: 309, value: 'Lapponian Herder' },
  { id: 310, value: 'Large Münsterländer' },
  { id: 311, value: 'Leonberger' },
  { id: 312, value: 'Levriero Sardo' },
  { id: 313, value: 'Lhasa Apso' },
  { id: 314, value: 'Liangshan Dog' },
  { id: 315, value: 'Lithuanian Hound' },
  { id: 316, value: 'Lobito Herreño' },
  { id: 317, value: 'Löwchen' },
  { id: 318, value: 'Lucas Terrier' },
  { id: 319, value: 'Lupo Italiano' },
  { id: 320, value: 'Mackenzie River husky' },
  { id: 321, value: 'Magyar Agár' },
  { id: 322, value: 'Mahratta Hound' },
  { id: 323, value: 'Majorca Shepherd Dog' },
  { id: 324, value: 'Maltese' },
  { id: 325, value: 'Manchester Terrier' },
  { id: 326, value: 'Maneto' },
  { id: 327, value: 'Markiesje' },
  { id: 328, value: 'Maremmano-Abruzzese Sheepdog' },
  { id: 329, value: 'McNab' },
  { id: 330, value: 'Miniature American Shepherd' },
  { id: 331, value: 'Miniature Bull Terrier' },
  { id: 332, value: 'Miniature Fox Terrier' },
  { id: 333, value: 'Miniature Pinscher' },
  { id: 334, value: 'Miniature Schnauzer' },
  { id: 335, value: 'Molossus of Epirus' },
  { id: 336, value: 'Mongrel' },
  { id: 337, value: 'Montenegrin Mountain Hound' },
  { id: 338, value: 'Moscow Watchdog' },
  { id: 339, value: 'Mountain Cur' },
  { id: 340, value: 'Mountain Feist' },
  { id: 341, value: 'Mudhol Hound' },
  { id: 342, value: 'Mudi' },
  { id: 343, value: 'Neapolitan Mastiff' },
  { id: 344, value: 'Nenets Herding Laika' },
  { id: 345, value: 'New Guinea singing dog' },
  { id: 346, value: 'New Zealand Heading Dog' },
  { id: 347, value: 'Newfoundland' },
  { id: 348, value: 'Norfolk Terrier' },
  { id: 349, value: 'Norrbottenspets' },
  { id: 350, value: 'Northern Inuit Dog' },
  { id: 351, value: 'Norwegian Buhund' },
  { id: 352, value: 'Norwegian Elkhound' },
  { id: 353, value: 'Norwegian Lundehund' },
  { id: 354, value: 'Norwich Terrier' },
  { id: 355, value: 'Nova Scotia Duck Tolling Retriever' },
  { id: 356, value: 'Old Danish Pointer' },
  { id: 357, value: 'Old English Sheepdog' },
  { id: 358, value: 'Olde English Bulldogge' },
  { id: 359, value: 'Otterhound' },
  { id: 360, value: 'Pachón Navarro' },
  { id: 361, value: 'Pampas Deerhound' },
  { id: 362, value: 'Papillon' },
  { id: 363, value: 'Parson Russell Terrier' },
  { id: 364, value: 'Pastor Garafiano' },
  { id: 365, value: 'Pastore della Lessinia e del Lagorai' },
  { id: 366, value: 'Patagonian Sheepdog' },
  { id: 367, value: 'Patterdale Terrier' },
  { id: 368, value: 'Pekingese' },
  { id: 369, value: 'Pembroke Welsh Corgi' },
  { id: 370, value: 'Perdigueiro Galego' },
  { id: 371, value: 'Perro Majorero' },
  { id: 372, value: 'Peruvian Hairless Dog' },
  { id: 373, value: 'Petit Basset Griffon Vendéen' },
  { id: 374, value: 'Petit Bleu de Gascogne' },
  { id: 375, value: 'Phalène' },
  { id: 376, value: 'Pharaoh Hound' },
  { id: 377, value: 'Phu Quoc Ridgeback' },
  { id: 378, value: 'Picardy Spaniel' },
  { id: 379, value: 'Plummer Terrier' },
  { id: 380, value: 'Plott Hound' },
  { id: 381, value: 'Podenco Andaluz' },
  { id: 382, value: 'Podenco Canario' },
  { id: 383, value: 'Podenco Valenciano' },
  { id: 384, value: 'Pointer' },
  { id: 385, value: 'Poitevin' },
  { id: 386, value: 'Polish Greyhound' },
  { id: 387, value: 'Polish Hound' },
  { id: 388, value: 'Polish Lowland Sheepdog' },
  { id: 389, value: 'Pomeranian' },
  { id: 390, value: 'Pont-Audemer Spaniel' },
  { id: 391, value: 'Poodle' },
  { id: 392, value: 'Porcelaine' },
  { id: 393, value: 'Portuguese Podengo' },
  { id: 394, value: 'Portuguese Pointer' },
  { id: 395, value: 'Portuguese Sheepdog' },
  { id: 396, value: 'Portuguese Water Dog' },
  { id: 397, value: 'Posavac Hound' },
  { id: 398, value: 'Pražský Krysařík' },
  { id: 399, value: 'Presa Canario' },
  { id: 400, value: 'Pudelpointer' },
  { id: 401, value: 'Pug' },
  { id: 402, value: 'Puli' },
  { id: 403, value: 'Pumi' },
  { id: 404, value: 'Pungsan' },
  { id: 405, value: 'Pyrenean Mastiff' },
  { id: 406, value: 'Pyrenean Mountain Dog' },
  { id: 407, value: 'Pyrenean Sheepdog' },
  { id: 408, value: 'Rafeiro do Alentejo' },
  { id: 409, value: 'Rajapalayam' },
  { id: 410, value: 'Rampur Greyhound' },
  { id: 411, value: 'Rastreador Brasileiro' },
  { id: 412, value: 'Rat Terrier' },
  { id: 413, value: 'Ratonero Bodeguero Andaluz' },
  { id: 414, value: 'Ratonero Murciano' },
  { id: 415, value: 'Redbone Coonhound' },
  { id: 416, value: 'Rhodesian Ridgeback' },
  { id: 417, value: 'Rize Koyun' },
  { id: 418, value: 'Romanian Mioritic Shepherd Dog' },
  { id: 419, value: 'Romanian Raven Shepherd Dog' },
  { id: 420, value: 'Rottweiler' },
  { id: 421, value: 'Rough Collie' },
  { id: 422, value: 'Russian Spaniel' },
  { id: 423, value: 'Russkiy Toy' },
  { id: 424, value: 'Russo-European Laika' },
  { id: 425, value: 'Ryukyu' },
  { id: 426, value: 'Sabueso Español' },
  { id: 427, value: 'Saint Miguel Cattle Dog' },
  { id: 428, value: 'Saint-Usuge Spaniel' },
  { id: 429, value: 'Sakhalin Husky' },
  { id: 430, value: 'Saluki' },
  { id: 431, value: 'Samoyed' },
  { id: 432, value: 'Sapsali' },
  { id: 433, value: 'Sarabi' },
  { id: 434, value: 'Sardinian Shepherd Dog' },
  { id: 435, value: 'Šarplaninac' },
  { id: 436, value: 'Schapendoes' },
  { id: 437, value: 'Schillerstövare' },
  { id: 438, value: 'Schipperke' },
  { id: 439, value: 'Schweizer Laufhund' },
  { id: 440, value: 'Schweizerischer Niederlaufhund' },
  { id: 441, value: 'Scottish Deerhound' },
  { id: 442, value: 'Scottish Terrier' },
  { id: 443, value: 'Sealyham Terrier' },
  { id: 444, value: 'Segugio dell Appennino' },
  { id: 445, value: 'Segugio Italiano' },
  { id: 446, value: 'Segugio Maremmano' },
  { id: 447, value: 'Serbian Hound' },
  { id: 448, value: 'Serbian Tricolour Hound' },
  { id: 449, value: 'Serrano Bulldog' },
  { id: 450, value: 'Shar Pei' },
  { id: 451, value: 'Shetland Sheepdog' },
  { id: 452, value: 'Shiba Inu' },
  { id: 453, value: 'Shih Tzu' },
  { id: 454, value: 'Shikoku' },
  { id: 455, value: 'Shiloh Shepherd' },
  { id: 456, value: 'Siberian Husky' },
  { id: 457, value: 'Silken Windhound' },
  { id: 458, value: 'Sinhala Hound' },
  { id: 459, value: 'Skye Terrier' },
  { id: 460, value: 'Sloughi' },
  { id: 461, value: 'Slovak Rough-haired Pointer' },
  { id: 462, value: 'Slovak Cuvac' },
  { id: 463, value: 'Slovenský kopov' },
  { id: 464, value: 'Smaland Hound' },
  { id: 465, value: 'Small Münsterländer' },
  { id: 466, value: 'Smithfield' },
  { id: 467, value: 'Smooth Collie' },
  { id: 468, value: 'Smooth Fox Terrier' },
  { id: 469, value: 'Soft-coated Wheaten Terrier' },
  { id: 470, value: 'South Russian Ovcharka' },
  { id: 471, value: 'Spanish Mastiff' },
  { id: 472, value: 'Spanish Water Dog' },
  { id: 473, value: 'Spino degli Iblei' },
  { id: 474, value: 'Spinone Italiano' },
  { id: 475, value: 'Sporting Lucas Terrier' },
  { id: 476, value: 'St. Bernard' },
  { id: 477, value: 'St. Hubert Jura Hound' },
  { id: 478, value: 'Stabyhoun' },
  { id: 479, value: 'Staffordshire Bull Terrier' },
  { id: 480, value: 'Standard Schnauzer' },
  { id: 481, value: 'Stephens Stock' },
  { id: 482, value: 'Styrian Coarse-haired Hound' },
  { id: 483, value: 'Sussex Spaniel' },
  { id: 484, value: 'Swedish Lapphund' },
  { id: 485, value: 'Swedish Vallhund' },
  { id: 486, value: 'Taigan' },
  { id: 487, value: 'Taiwan Dog' },
  { id: 488, value: 'Tamaskan Dog' },
  { id: 489, value: 'Tang Dog' },
  { id: 490, value: 'Tarsus çatalburun' },
  { id: 491, value: 'Tatra Shepherd Dog' },
  { id: 492, value: 'Tazy' },
  { id: 493, value: 'Teddy Roosevelt Terrier' },
  { id: 494, value: 'Telomian' },
  { id: 495, value: 'Tenterfield Terrier' },
  { id: 496, value: 'Thai Bangkaew Dog' },
  { id: 497, value: 'Thai Ridgeback' },
  { id: 498, value: 'Tibetan Kyi Apso' },
  { id: 499, value: 'Tibetan Mastiff' },
  { id: 500, value: 'Tibetan spaniel' },
  { id: 501, value: 'Tibetan Terrier' },
  { id: 502, value: 'Tonya Finosu' },
  { id: 503, value: 'Tornjak' },
  { id: 504, value: 'Tosa' },
  { id: 505, value: 'Toy Fox Terrier' },
  { id: 506, value: 'Toy Manchester Terrier' },
  { id: 507, value: 'Transylvanian Hound' },
  { id: 508, value: 'Treeing Cur' },
  { id: 509, value: 'Treeing Feist' },
  { id: 510, value: 'Treeing Tennessee Brindle' },
  { id: 511, value: 'Treeing Walker Coonhound' },
  { id: 512, value: 'Trigg Hound' },
  { id: 513, value: 'Tyrolean Hound' },
  { id: 514, value: 'Valencian Terrier' },
  { id: 515, value: 'Vikhan' },
  { id: 516, value: 'Villano de Las Encartaciones' },
  { id: 517, value: 'Villanuco de Las Encartaciones' },
  { id: 518, value: 'Vizsla' },
  { id: 519, value: 'Volkosob' },
  { id: 520, value: 'Volpino Italiano' },
  { id: 521, value: 'Weimaraner' },
  { id: 522, value: 'Welsh Hound' },
  { id: 523, value: 'Welsh Sheepdog' },
  { id: 524, value: 'Welsh Springer Spaniel' },
  { id: 525, value: 'Welsh Terrier' },
  { id: 526, value: 'West Country Harrier' },
  { id: 527, value: 'West Highland White Terrier' },
  { id: 528, value: 'West Siberian Laika' },
  { id: 529, value: 'Westphalian Dachsbracke' },
  { id: 530, value: 'Wetterhoun' },
  { id: 531, value: 'Whippet' },
  { id: 532, value: 'White Shepherd' },
  { id: 533, value: 'White Swiss Shepherd Dog' },
  { id: 534, value: 'Wire Fox Terrier' },
  { id: 535, value: 'Wirehaired Pointing Griffon' },
  { id: 536, value: 'Wirehaired Vizsla' },
  { id: 537, value: 'Xiasi Dog' },
  { id: 538, value: 'Xoloitzcuintle' },
  { id: 539, value: 'Yakutian Laika' },
  { id: 540, value: 'Yorkshire Terrier' },
  { id: 541, value: 'Zerdava' },
];
